<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_email_status_title' | translate }}</h4>

  <div class="table-wrapper">
    <table mat-table [dataSource]="emailData" class="mat-elevation-z8">
      <ng-container matColumnDef="Expéditeur">
        <th mat-header-cell *matHeaderCellDef>{{ 'dialog_email_status_col_sender' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element['from'] }}</td>
      </ng-container>

      <ng-container matColumnDef="Sujet">
        <th mat-header-cell *matHeaderCellDef>{{ 'dialog_email_status_col_subject' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element['subject'] }}</td>
      </ng-container>

      <ng-container matColumnDef="Date">
        <th mat-header-cell *matHeaderCellDef>{{ 'dialog_email_status_col_date' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element['createDate'] | localizedDate: 'short' }}</td>
      </ng-container>

      <ng-container matColumnDef="Statut">
        <th mat-header-cell *matHeaderCellDef>{{ 'dialog_email_status_col_status' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          {{ element['sentLabel'] }}
          <div class="status-error" *ngIf="element['rejectedCount']">{{ 'email_rejected_count' | translate: { count: element['rejectedCount'] } }}</div>
          <div class="status-error" *ngIf="!element['sent'] && element['errorMessage']">{{ element['errorMessage'] }}</div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row class="clickable-row" *matRowDef="let row; columns: columnsToDisplay" (click)="openDetail(row)"></tr>
    </table>
  </div>

  <div mat-dialog-actions>
    <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_back' | translate }}</button>
  </div>
</div>
